import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const RecentView = createAsyncThunk(
  "viewData/recentView",
  async (productId, thunkAPI) => {
    try {
      const storedUuid = localStorage.getItem("uuid");
      const Token = localStorage.getItem("loginData");
      const response = await axios.post(
        endPoint.RECENTVIEW,
        { productId: productId },
        {
          headers: {
            sessionId: storedUuid ? storedUuid : "",
            Authorization: Token ? `Bearer ${Token}` : "",
          },
        }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const RecentViewSlice = createSlice({
  name: "View",
  initialState: {
    View: [],
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(RecentView.fulfilled, (state, action) => {
        state.View = action.payload;
      })
      .addCase(RecentView.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default RecentViewSlice.reducer;
